var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmpresa(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "27px",
    height: "28px",
    viewBox: "0 0 27 28",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "empresa") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    strokeDasharray: "0,0",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("g", {
    id: "B-Liner_Mobile_Claro2",
    transform: "translate(-263.000000, -2131.000000)",
    fillRule: "nonzero",
    stroke: "",
    strokeWidth: 2.1
  }, /*#__PURE__*/React.createElement("g", {
    id: "menu",
    transform: "translate(0.000000, 2012.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "group-copy",
    transform: "translate(255.000000, 121.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "empresa",
    transform: "translate(10.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.79901248,10.746088 C4.93680753,10.6491672 2.66388034,8.28672429 2.66388034,5.37910168 C2.66388034,2.41090366 5.04504235,0 8.00345577,0 C10.9498431,0 13.3430301,2.41090366 13.3430301,5.37910168 C13.331004,8.28672429 11.0580777,10.6491672 8.19587272,10.746088 C8.07561201,10.7339729 7.93129925,10.7339729 7.79901248,10.746088 Z",
    id: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.9147378,2.42301874 C19.2477956,2.42301874 21.1238625,4.32508852 21.1238625,6.66330154 C21.1238625,8.95305424 19.3199532,10.8187787 17.071078,10.9035843 C16.9748694,10.8914692 16.8666345,10.8914692 16.7583999,10.9035843",
    id: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.18273189,22.3281175 C5.48990131,24.5572948 10.91366,24.5572948 14.2208294,22.3281175 C17.1311386,20.3654723 17.1311386,17.1670879 14.2208294,15.2165578 C10.9256861,12.9994956 5.50192737,12.9994956 2.18273189,15.2165578 C-0.727577296,17.179203 -0.727577296,20.3775874 2.18273189,22.3281175 Z",
    id: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.2358409,21.8071687 C20.101718,21.6254423 20.9194897,21.2741036 21.5929496,20.7531545 C23.4690166,19.3356886 23.4690166,16.997476 21.5929496,15.5800101 C20.9315157,15.0711762 20.1257709,14.731954 19.2719199,14.5381125",
    id: "Vector"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmpresa);
export default __webpack_public_path__ + "static/media/empresa.87439a16a024ab77d0b835ca54dfa455.svg";
export { ForwardRef as ReactComponent };